(function($) {

  $(function() {

    $('#user_login').attr('placeholder', 'E-mail')
    $('#user_pass').attr('placeholder', 'Contraseña')
    $('#wp-submit').attr('value', 'Entrar')

    $('#backtoblog').remove()
    $('.privacy-policy-page-link').remove()

    const $nav = $('#login #nav').remove()
    $nav.insertBefore($('#loginform .forgetmenot'))

    const $lostpaswordform = $('#lostpasswordform')
    if($lostpaswordform.length) {

      $('#wp-submit').attr('value', 'Enviar')      
    }

    $('#login').wrapInner('<div class="Wrapper"></div>')

    $('<div class="logo-suntory"></div>').insertAfter('#loginform')

    $('body').append(`
      <div id="splash">
        <div class="logoligaaguila"></div>
        <div class="logosuntory"></div>
      </div>
    `)
    const $splash = $('#splash')

    setTimeout(() => {

      $splash.fadeOut(function() {

        $splash.remove()
      })

    }, 3000)
  })

})(jQuery)